import React from 'react';
import ViolationListHeader from './ViolationListHeader';
import ViolationListItem from './ViolationListItem';
import { ViolationListStyle } from './ViolationListView.styles';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';

const ViolationListContentComponent: React.FC = () => {
    const { filteredViolations } = useStowageSelectionStore();
    return (
        <ViolationListStyle>
            <ViolationListHeader />
            {filteredViolations?.map((violation) => (
                <ViolationListItem violation={violation} key={'violation-' + violation.violationGuid} />
            ))}
        </ViolationListStyle>
    );
};

export default ViolationListContentComponent;
